var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCategoryDeletedIcon = function SvgCategoryDeletedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "212px",
    height: "214px",
    viewBox: "0 0 212 214",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.081817,41.4602739 C156.769002,54.305254 165.074332,75.9477073 162.549511,98.4264223 C160.057912,120.871687 146.769384,144.086312 129.195306,148.970081 C111.654448,153.853849 89.8280407,140.406761 68.7989448,128.866349 C47.7698489,117.292487 27.4716221,107.658752 22.3555387,92.4053379 C17.2394554,77.1853746 27.2722942,56.379183 41.2584701,43.4673021 C55.244646,30.5554211 73.1841591,25.5378508 91.6884346,25.0360938 C110.225931,24.5677872 129.361412,28.5818435 143.081817,41.4602739 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.794114,51.2466513 C181.478104,64.0536648 164.146215,78.1665866 161.621984,100.57886 C159.130966,122.957783 145.845538,146.103792 128.275561,150.973125 C110.738796,155.842458 88.9174815,142.435116 67.8932925,130.928815 C46.8691034,119.389162 26.5756128,109.783901 21.4607232,94.5755728 C16.3458336,79.4005958 12.9202504,58.256181 26.9031629,45.3824642 C40.8860754,32.5087474 45.1907001,-7.49626196 63.6906579,-7.99653593 C82.2238293,-8.4634583 154.07691,38.4062861 167.794114,51.2466513 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0848334,31.3264754 L97.0848334,26.5070177 L97.0848334,31.3264754 L4.97870941,31.3264754 L-8.61819576e-14,31.3264754 L-8.61819576e-14,9.63891552 C-8.61819576e-14,4.32305361 4.46590234,1.45432053e-13 9.95741881,1.45432053e-13 L39.8296752,1.45432053e-13 C40.4121842,1.45432053e-13 40.9747784,0.197597768 41.4228623,0.556647371 L55.6669499,12.0486444 L87.1274146,12.0486444 C92.6189311,12.0486444 97.0848334,16.371698 97.0848334,21.6875599 L97.0848334,31.3264754 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1370301,29.7425569 C20.4225961,25.4648121 25.0789506,21.9970148 29.5546626,21.9970148 L113.266132,21.9970148 C117.734066,21.9970148 120.540402,25.5267697 119.534651,29.8792468 L106.673011,85.5391468 C105.667085,89.8923833 101.22718,93.4213788 96.7548132,93.4213788 L8.09680685,93.4213788 C3.6250639,93.4213788 1.04254362,89.9522956 2.32772321,85.6758367 L19.1370301,29.7425569 Z",
    id: "path-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockups---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Organization-folder-created-",
    transform: "translate(-622.000000, -384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-plan---modal-selected-Copy",
    transform: "translate(410.000000, 374.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(223.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "mask",
    fill: "#DFF6FB",
    fillRule: "nonzero",
    transform: "translate(92.000000, 87.500000) scale(-1, 1) rotate(-26.000000) translate(-92.000000, -87.500000) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mask",
    fillRule: "nonzero",
    transform: "translate(95.000000, 72.000000) scale(-1, 1) rotate(-26.000000) translate(-95.000000, -72.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4864865,29 C8.37248771,29 9.09073361,29.7182459 9.09073361,30.6042471 L9.09073361,30.6042471 L9.09,34.882 L13.3687259,34.8822394 C14.2055048,34.8822394 14.8926501,35.522897 14.966417,36.3404673 L14.972973,36.4864865 C14.972973,37.3724877 14.2547271,38.0907336 13.3687259,38.0907336 L13.3687259,38.0907336 L9.09,38.09 L9.09073361,42.3687259 C9.09073361,43.2055048 8.450076,43.8926501 7.63250569,43.966417 L7.4864865,43.972973 C6.60048529,43.972973 5.88223939,43.2547271 5.88223939,42.3687259 L5.88223939,42.3687259 L5.882,38.09 L1.60424711,38.0907336 C0.767468184,38.0907336 0.0803228628,37.450076 0.00655603356,36.6325057 L1.13686838e-13,36.4864865 C1.13686838e-13,35.6004853 0.718245895,34.8822394 1.60424711,34.8822394 L1.60424711,34.8822394 L5.882,34.882 L5.88223939,30.6042471 C5.88223939,29.7674682 6.522897,29.0803229 7.34046731,29.006556 Z",
    id: "Combined-Shape-Copy",
    fill: "#FCC78C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#84CFEC",
    cx: 26.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#8AD28F",
    cx: 169.5,
    cy: 47.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#CEA8EF",
    strokeWidth: 2,
    cx: 156.5,
    cy: 4.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(35.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12409596e-13,20.2808688 L95.9069264,20.2808688 L95.9069264,83.6161688 C95.9069264,88.0836354 92.2933896,91.7052327 87.8126119,91.7052327 L8.09431451,91.7052327 C3.62394804,91.7052327 3.12409596e-13,88.0897536 3.12409596e-13,83.6161688 L3.12409596e-13,20.2808688 Z",
    id: "Rectangle-path",
    fill: "#E0C28B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E0C28B",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "#F9BA48",
    xlinkHref: "#path-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(129.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E02020",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16.8836556,8 17.6,8.76751186 17.6,9.71428571 L17.6,9.71428571 L17.6,14.399 L22.2857143,14.4 C23.1826579,14.4 23.9187127,15.0429241 23.9937075,15.8619459 L24,16 C24,16.8836556 23.2324881,17.6 22.2857143,17.6 L22.2857143,17.6 L17.6,17.599 L17.6,22.2857143 C17.6,23.1826579 16.9570759,23.9187127 16.1380541,23.9937075 L16,24 C15.1163444,24 14.4,23.2324881 14.4,22.2857143 L14.4,22.2857143 L14.4,17.6 L9.71428571,17.6 C8.81734206,17.6 8.08128729,16.9570759 8.00629245,16.1380541 L8,16 C8,15.1163444 8.76751186,14.4 9.71428571,14.4 L9.71428571,14.4 L14.4,14.4 L14.4,9.71428571 C14.4,8.81734206 15.0429241,8.08128729 15.8619459,8.00629245 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(16.000000, 16.000000) rotate(45.000000) translate(-16.000000, -16.000000) "
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCategoryDeletedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/categoryDeletedIcon.d98458b0.svg";
export { ForwardRef as ReactComponent };